import { useEffect, useState } from "react";
import { Loader2, Mail } from "lucide-react";
import { AdminNav } from "@/components/admin/AdminNav";
import { AdminAccessDenied } from "@/components/admin/AdminAccessDenied";
import { AdminLoading, useAdminAuth } from "@/components/admin/useAdminAuth";

const API = process.env.REACT_APP_BACKEND_URL;

const formatDate = (value) => {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? "—" : date.toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};

export default function AdminJobAlerts() {
    const { user, logout, hasPermission } = useAdminAuth();
    const [items, setItems] = useState(null);

    useEffect(() => {
        const allowed = Boolean(user?.permissions?.includes("*") || user?.permissions?.includes("alerts"));
        if (!user || !allowed) return;
        fetch(`${API}/api/admin/job-alerts`, { credentials: "include" })
            .then((r) => (r.ok ? r.json() : []))
            .then(setItems)
            .catch(() => setItems([]));
    }, [user]);

    if (!user) return <AdminLoading />;

    return (
        <div className="min-h-screen bg-[#F8FAFC] font-adminSans text-[#0F172A]">
            <AdminNav active="alerts" email={user.email} user={user} onLogout={logout} />
            {!hasPermission("alerts") ? <AdminAccessDenied section="job alerts" /> : (
                <main className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
                    <h1 className="font-adminDisplay text-4xl font-bold tracking-tight">Job Alerts</h1>
                    <p className="mt-2 text-sm text-[#64748B]">Candidate subscribers notified when matching roles are published.</p>
                    <div className="mt-8 rounded-lg border border-[#E2E8F0] bg-white shadow-sm" data-testid="job-alerts-list">
                        {items === null ? (
                            <div className="flex justify-center py-20"><Loader2 className="animate-spin text-[#0B1120]" /></div>
                        ) : items.length === 0 ? (
                            <p className="py-16 text-center text-sm text-[#64748B]">No job alert subscribers yet.</p>
                        ) : (
                            <div className="divide-y divide-[#E2E8F0]">
                                {items.map((item) => (
                                    <div key={item.id} className="grid gap-3 px-5 py-4 sm:grid-cols-[1fr_auto] sm:items-center" data-testid={`job-alert-${item.id}`}>
                                        <div className="min-w-0">
                                            <p className="flex items-center gap-2 truncate text-sm font-semibold"><Mail size={14} className="text-[#D4AF37]" /> {item.email}</p>
                                            <p className="mt-1 truncate text-xs text-[#64748B]">
                                                {[item.profession, item.country, item.industry].filter(Boolean).join(" · ") || "All published roles"}
                                            </p>
                                        </div>
                                        <span className="text-xs text-[#94A3B8]">{formatDate(item.updated_at || item.created_at)}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </main>
            )}
        </div>
    );
}
